import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';
import { Material } from '../types/Material.type';

@Injectable({
  providedIn: 'root'
})
export class MaterialService {

  constructor(private httpClient: HttpClient, private configService: ConfigService) { }
  
    getAll() {
      return this.httpClient.get<Material[]>(this.configService.getApiUrlRoot() + "/materiais/");
    }

  exportar(){
    return this.httpClient.get(`${this.configService.getApiUrlRoot()}/materiais/relatorios/exportar`, { responseType: 'blob'})
  }
}
